import {connect} from 'react-redux';
import {ContentItemViewMetadataState} from 'ContentItemView/ContentItemViewMetadata/ContentItemViewMetadataTypes';
import {
    resetQcJobStateAction,
    resetJobDeliveryStatusAction,
    deliveryContentItemAction,
} from './Redux/ContentItemViewActions';
import {QcJobStatusIndicatorState} from './JobStatusIndicator/JobStatusIndicatorTypes';
import {
    resetContentItemViewMetadataAction,
    setContentItemViewMetadataAction,
} from './ContentItemViewMetadata/Redux/ContentItemViewMetadataActions';
import ContentItemViewContainer from './ContentItemViewContainer';
import {DeliveryJobsStatusPayload} from './ContentItemViewTypes';
import {
    Item,
    resetItemAction,
    setItemAction,
} from './VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {QCMediaState} from './VideoAudioQC/QCMedia/Redux/QCMediaReducer';
import {
    getDeliveryJobsStatusAction,
    setQcJobStateAction,
} from '../QCTools/Redux/QCToolsActions';

export type State = {
    videoAudioQC: {
        qcMedia: QCMediaState;
    };
    contentItemView: {
        statusIndicators: QcJobStatusIndicatorState;
        contentItemViewMetadata: ContentItemViewMetadataState;
        jobDeliveryStatus: DeliveryJobsStatusPayload;
    };
};

export interface ContentItemViewMapState extends QcJobStatusIndicatorState {
    isMetadataLoading: boolean;
    contentType: string | undefined;
    item: Item | null;
}

export const mapState = (state: State): ContentItemViewMapState => {
    const {contentItemView} = state;
    const {item} = state.videoAudioQC.qcMedia;
    const {
        statusIndicators,
        contentItemViewMetadata,
        jobDeliveryStatus,
    } = contentItemView;
    const {isLoading: isMetadataLoading, general} = contentItemViewMetadata;
    const {contentType}: any = general;

    return {
        ...statusIndicators,
        ...jobDeliveryStatus,
        isMetadataLoading,
        contentType,
        item,
    };
};

const mapDispatch = {
    setQcJobState: setQcJobStateAction,
    resetQcJobState: resetQcJobStateAction,
    setQcMetadata: setContentItemViewMetadataAction,
    resetQcMetadata: resetContentItemViewMetadataAction,
    getDeliveryJobStatus: getDeliveryJobsStatusAction,
    resetJobDeliveryStatus: resetJobDeliveryStatusAction,
    deliveryJob: deliveryContentItemAction,
    setItem: setItemAction as any,
    resetItem: resetItemAction,
};

export default connect(mapState, mapDispatch)(ContentItemViewContainer);
